import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserKyiSaleGroup } from 'src/app/core/model/user/user-kyi-sale-group';
import { LayoutService } from 'src/app/layout/layout.service';
import { Content } from 'src/app/models/content.model';
import { DynamicLayout } from 'src/app/models/dynamic-layout.model';

@Component({
  selector: 'app-previously-claimed-page',
  templateUrl: './previously-claimed-page.component.html',
  styleUrls: ['./previously-claimed-page.component.scss'],
})
export class PreviouslyClaimedPageComponent implements OnInit, DynamicLayout {
  @Input()
  baseContent: Content;

  content: string;

  saleDetails: UserKyiSaleGroup;
  constructor(private layoutService: LayoutService, private router: Router) {}

  ngOnInit(): void {
    const titleField = this.baseContent.fields.find((f) => f.name === 'Title');
    const bannerField = this.baseContent.fields.find((f) => f.name === 'Banner');

    const contentField = this.baseContent.fields.find((f) => f.name === 'Content');

    this.content = contentField.value.value;

    this.layoutService.changeBanner({
      title: titleField.value.value,
      imageUrl: bannerField.value.url,
    });
  }

  viewDetails(sale: UserKyiSaleGroup): void {
    this.router.navigate(['/sale-details/' + sale.id]);
  }
}
